/**
 * Type-to-search over a product list: what a product dropdown shows for the
 * text typed into its search box.
 */
export interface SearchableProduct {
	id: number;
	name?: string | null;
	itemNumber?: string | null;
	sku?: string | null;
}

/** True when the product's name, item number or SKU contains the query, ignoring case. */
export const productMatches = (product: SearchableProduct, query: string): boolean => {
	const needle = query.trim().toLowerCase();
	if (!needle) return true;
	return [product.name, product.itemNumber, product.sku].some((field) => (field ?? "").toLowerCase().includes(needle));
};

export interface ProductSearchResult<T extends SearchableProduct> {
	/** What the menu lists: the matches, plus the selected product so the closed field never goes blank. */
	visible: T[];
	/** True when the query matched nothing (the kept selection does not count as a match). */
	isEmpty: boolean;
}

export const filterProducts = <T extends SearchableProduct>(
	products: T[],
	query: string,
	selectedId?: number | "" | null
): ProductSearchResult<T> => {
	let matchCount = 0;
	const visible = products.filter((product) => {
		const isMatch = productMatches(product, query);
		if (isMatch) matchCount += 1;
		return isMatch || product.id === selectedId;
	});
	return { visible, isEmpty: matchCount === 0 };
};
